import { render, staticRenderFns } from "./SelectEndOfExerciseNew.vue?vue&type=template&id=ec0ba2bc&scoped=true"
import script from "./SelectEndOfExerciseNew.vue?vue&type=script&lang=js"
export * from "./SelectEndOfExerciseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0ba2bc",
  null
  
)

export default component.exports